import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { Select, Typography, Flex, Card } from 'antd';

import messages from '../../../constants/messages';

import { useExternalScript } from '../../../hooks/useExternalScript';

import { fetchEmbeddableToken } from '../../../redux/actions/embeddable';

import LoadingBar from '../../../components/LoadingBar';
import { errorToastHandler } from '../../../components/action_notifier';

import Embeddable from './Embeddable';

const { Title } = Typography;
let firstTime = true;

function Analytics() {
  const dispatch = useDispatch();
  const { token, loading } = useSelector(state => state.embeddable);
  const scriptStatus = useExternalScript(process.env.REACT_APP_EMBEDDABLE_SCRIPT);
  const [selectedReport, setSelectedReport] = useState('age');
 

  const reportOptions = [
    { label: 'Age report', value: 'age' },
    { label: 'Herd report', value: 'herd' },
  ];

  useEffect(() => {
    fetchToken(selectedReport);
  }, []);

  async function fetchToken(reportName) {
    try {
      await dispatch(fetchEmbeddableToken(reportName)).unwrap();
      setSelectedReport(reportName);
      firstTime = false;
    } catch (error) {
      errorToastHandler(error?.message || error?.response?.data?.message || messages.FAILED_ON_FETCH_DATA);
    }
  }

  const handleReportChange = (newReportType) => {  
    fetchToken(newReportType); 
  };

  if (loading && firstTime) {
    return <LoadingBar fullscreen={true} />;
  }

  return (
    <>
      <Card>
        <Title level={4}>Reports</Title>
        <Flex align="center" justify="flex-start" gap="small" className="mb-2 w-full" wrap>
          <p style={{marginBottom: 0}}>Select report</p>
          <Select
            name="type"
            value={selectedReport}
            onChange={value => handleReportChange(value)}
            optionFilterProp="label"
            options={reportOptions}
          />
        </Flex>
        {token && scriptStatus === 'ready' && <Embeddable token={token}/>}
      </Card>
    </>);
}

export default memo(Analytics);
